import script from "./DataSourceUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./DataSourceUpdate.vue?vue&type=script&setup=true&lang=js"

import "./DataSourceUpdate.vue?vue&type=style&index=0&id=1f212ddf&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f212ddf"]])

export default __exports__